import { render, staticRenderFns } from "./skillScore.vue?vue&type=template&id=e236b6f0&scoped=true&"
import script from "./skillScore.vue?vue&type=script&lang=js&"
export * from "./skillScore.vue?vue&type=script&lang=js&"
import style0 from "./skillScore.vue?vue&type=style&index=0&id=e236b6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e236b6f0",
  null
  
)

export default component.exports